import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ButtonComponent } from "../../../shared/component/buttons/button.component";
import { InputComponent } from "../../../shared/component/inputs/input-component/input.component";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import {
  SelectorAutocompleteComponent,
} from "../../../shared/component/inputs/selector-autocomplete/selector-autocomplete.component";
import { Countries, COUNTRY_KEY_IN_STORAGE } from "../../../../util/common/countries";
import { SelectorComponent } from "../../../shared/component/inputs/selector/selector.component";
import {
  OrganizationType,
  organizationTypesMap,
  reversedOrganizationTypesMap,
} from "../../dto/organization-type";
import { OrganizationBackendService } from "../../service/organization-backend.service";
import { OrganizationDTO } from "../../dto/OrganizationDTO";
import { firstValueFrom } from "rxjs";
import { Router } from "@angular/router";
import { InitStateBusinessService } from "../../../../core/service/init-state-business.service";
import { NgClass } from "@angular/common";
import { FRONT_URLS } from "../../../../util/common/url-parts";
import { EntranceService } from "../../../entrance/service/entrance.service";

@Component({
  selector: 'app-new-organization',
  imports: [
    ButtonComponent,
    InputComponent,
    ReactiveFormsModule,
    SelectorAutocompleteComponent,
    SelectorComponent,
    NgClass,
  ],
  templateUrl: './new-organization.html',
  styleUrls: [
    './new-organization.scss',
    '../../../entrance/component/base/entrance.component.scss',
    '../../../login/entrance-group.scss',
  ],
  standalone: true,
})
export class NewOrganization implements OnInit {
  private router = inject(Router);
  private organizationBackendService = inject(OrganizationBackendService);
  private initService = inject(InitStateBusinessService);
  private entranceService = inject(EntranceService);

  protected readonly countries = Countries;
  protected readonly Array = Array;
  protected readonly organizationTypes = organizationTypesMap;
  protected readonly reversedOrganizationTypes = reversedOrganizationTypesMap;

  @Input() inModalMode: boolean = false;
  @Output() newOrgCreated = new EventEmitter<OrganizationDTO>();

  newOrganizationForm: NewOrganizationFG;

  ngOnInit(): void {
    this.initForm();
  }

  async continue(): Promise<void> {
    if (this.newOrganizationForm.invalid) {
      return;
    }

    const data: OrganizationDTO = {
      name: this.newOrganizationForm.value.name,
      webSiteLink: this.newOrganizationForm.value.website,
      country: this.newOrganizationForm.value.country,
      type: this.newOrganizationForm.value.type,
    };
    const newOrganization = await firstValueFrom(this.organizationBackendService.create(data));
    this.initService.refreshInitData();

    await this.router.navigate([FRONT_URLS.ENTRANCE], { queryParams: { o: newOrganization.uuid } });

    this.newOrgCreated.emit(newOrganization);
  }

  private initForm(): void {
    const country = localStorage.getItem(COUNTRY_KEY_IN_STORAGE);
    const companyName = this.entranceService.companyName$$();
    this.newOrganizationForm = new FormGroup({
      name: new FormControl<string>(companyName || '', { validators: [Validators.required] }),
      type: new FormControl<OrganizationType>(undefined, { validators: [Validators.required] }),
      country: new FormControl<string>(country || '', { validators: [Validators.required] }),
      website: new FormControl<string>(''),
    });
    if (companyName) {
      this.entranceService.clearCompanyName();
    }
  };
}

type NewOrganizationFG = FormGroup<{
  name: FormControl<string>,
  type: FormControl<OrganizationType>,
  country: FormControl<string>,
  website: FormControl<string>,
}>;
